const bossCardCollection = `

You can **collect Bosscards** and exchange them at the **BlackMarket Family NPC**.

⚠️ **Important:** Before exchanging cards, you **must remove your belt**.

![Bosscard Collection](assets/guide/sc_sammlung_us.png)`;

export default bossCardCollection;
